import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  CircularProgress,
} from '@mui/material';
import { endpoints } from '../services/endpoints';
import authFetch from '../utils/authFetch';

const UploadFileUI = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFile = (selected) => {
    setFile(selected);
    setFileName(selected.name);
    // show size in KB, MB, or GB
    let size = selected.size;
    let sizeStr = '';
    if (size > 1024 ** 3) {
      sizeStr = (size / 1024 ** 3).toFixed(2) + ' GB';
    } else if (size > 1024 ** 2) {
      sizeStr = (size / 1024 ** 2).toFixed(2) + ' MB';
    } else {
      sizeStr = (size / 1024).toFixed(2) + ' KB';
    }
    setFileSize(sizeStr);
  };

  const handleFileChange = (event) => {
    const selected = event.target.files?.[0];
    if (selected) {
      handleFile(selected);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleFile(event.dataTransfer.files[0]);
      event.dataTransfer.clearData();
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

const handleUpload = async () => {
  setUploadError(null);

  if (!file) {
    setUploadError("Please select a file.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  setLoading(true);

  try {
    const response = await authFetch.post(
      `${process.env.REACT_APP_BACKEND_URL}${endpoints.UPLOAD_EXCEL}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status !== 200) {
      throw new Error(response.data?.message || "Upload failed");
    }

    onUploadSuccess();
    setFile(null);
    setFileName(null);
    setFileSize(null);
  } catch (error) {
    setUploadError(
      error.response?.data?.message || error.message || "Upload failed"
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Upload File
      </Typography>

      <Box
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        sx={{
          border: '2px dashed',
          borderColor: 'grey.400',
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
          cursor: 'pointer',
          mb: 2,
          '&:hover': {
            borderColor: 'primary.main',
            backgroundColor: 'grey.100',
          },
          userSelect: 'none',
        }}
        onClick={() => document.getElementById('fileInput')?.click()}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
            color: 'primary.main',
          }}
        >
          {/* <CloudUploadIcon fontSize="large" /> */}
        </Box>
        <Typography variant="body1" color="text.secondary">
          <Typography
            component="span"
            variant="body1"
            color="primary"
            sx={{ textDecoration: 'underline' }}
          >
            Click To Upload
          </Typography>{' '}
          or drag and drop file here
        </Typography>
        <Typography color="error">
          * Upload only .xlsx *
        </Typography>

        <input
          id="fileInput"
          type="file"
          hidden
          accept=".xlsx"
          onChange={handleFileChange}
        />
      </Box>

      {fileName && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          Selected file: {fileName} ({fileSize})
        </Typography>
      )}

      <Button
        variant="contained"
        color="primary"
        disabled={!file || loading}
        onClick={handleUpload}
      >
        {loading ? <CircularProgress size={20} /> : 'Upload'}
      </Button>

      {uploadError && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {uploadError}
        </Typography>
      )}
    </Paper>
  );
};

export default UploadFileUI;